import cx from "classnames"
import * as React from "react"
import * as i18n from "tb-i18n"
import Card from "./card"

const styles = require("./main.styl")

interface WallDataType {
    icon: string
    title: string
    detail: string
    link: string
}

interface State {
    fold: boolean
}

interface Props {
    data: WallDataType[]
}

export default class ProjectTypeWall extends React.PureComponent<Props, State> {
    constructor(prop) {
        super(prop)
        this.state = { fold: false }
        window.addEventListener("resize", this.handleResize)
    }
    componentDidMount() {
        this.handleResize()
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize)
    }
    render() {
        const { fold } = this.state
        return (
            <div className={ cx(styles["project-type-wall"], { fold }) }>
                {this.renderCards()}
                {this.renderTip()}
            </div>
        )
    }
    renderCards() {
        const { data } = this.props
        return data.map(({ icon, title, detail, link }) => (
            <Card
                key={ title }
                icon={ icon }
                title={ title }
                detail={ detail }
                link={ link }
            />
        ))
    }
    renderTip() {
        const { fold } = this.state
        if (fold) {
            return (
                <div className="project-type-wall-tip" onClick={ this.unfold }>
                    {i18n.get("homepage.unfold")}
                    <span className="icon icon-chevron-down" />
                </div>
            )
        }
    }
    handleResize = () => {
        if (window.innerWidth > 768) {
            this.setState({ fold: false })
        } else {
            this.setState({ fold: true })
        }
    }
    unfold = () => {
        this.setState({ fold: false })
    }
}
